import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { environment } from '../../../environments/environment';

const http_options = {
	headers: new HttpHeaders({
		'Content-Type': 'application/json'
	})
};
class VehicleForm {
	owner_name:string;
	truck_no : string;
	branch: string;
	pan_no: string;
	account_no: string;
	bank_name: string;
	bank_branch: string;
	bank_ifsc: string;
	
}

@Injectable()
export class VehicleService {

	private url = environment.url;


	constructor(private http: HttpClient) { }


	addNewVehicle(form): Observable<string>{
		return this.http.post<string>(this.url + '/masters/vehicle/submit', form, http_options);
	};

	getAllVehicle(): Observable<VehicleForm[]> {
		return this.http.get<VehicleForm[]>(this.url + '/masters/vehicle/all');
	};
	getVehicleFormWith(name:string): Observable<VehicleForm[]> {
		return this.http.get<VehicleForm[]>(this.url + '/masters/vehicle/get/' + name);
	};
	getVehicleFormWithBranch(branch:string): Observable<VehicleForm[]> {
		return this.http.get<VehicleForm[]>(this.url + '/masters/vehicle/get/branch/' + branch);
	};
}



// WEBPACK FOOTER //
// /Users/meghneel/work/baba_frontend/src/app/_services/_masters/vehicle.service.ts